ubian = ubian || {};

ubian.cardVirtualize = {};

ubian.cardVirtualize.init = function () {
  if ($(".card-photo-preview").hasClass('has-photo')) {
    var bg = $(".card-photo-preview").css("background-image");
    bg = bg.replace('url(', '').replace(')', '').replace(/\"/gi, "");

    var image = new Image;
    image.src = bg;
    image.onload = function () {
      var ratio = image.width / image.height;
      var newH = 200;
      var newW = newH * ratio;

      $(".card-photo-preview").data('width', image.width);
      $(".card-photo-preview").data('height', image.height);
      $(".card-photo-preview").css('height', newH);
      $(".card-photo-preview").css('width', newW);
    }
  }

  $("#virtualize-profile-photo").change(function () {
    ubian.cardVirtualize.virtualUploadProfileImage();
  });

  if ($('.js-virtualize-agreement-tos').length) {
    $('.js-virtualize-agreement-tos').change(function () {
      $('.js-virtualize-agreement-tos-required').hide();
    });
  }

  $('.js-virtualize-form').submit(function (e) {
    var $form = $(this);
    var email = $form.find('input[name=email]');
    var phone = $form.find('input[name=phone]');
    var errors = false;

    $form.find('.error').removeClass('has-error');
    if (ubian.utils.validateEmail(email.val()) === false) {
      email.next('.error').addClass('has-error');
      errors = true;
    };

    if (ubian.utils.validatePhoneNumber(phone.val()) === false) {
      phone.next('.error').addClass('has-error');
      errors = true;
    };
    var customerImage = $('.customer-photo-preview').css('backgroundImage');
    var imageRequired = $('.customer-photo-preview').data('required');
    if (imageRequired && (!customerImage || customerImage == 'none')) {
      $('.profile-photo-error').addClass('has-error');
      errors = true;
    }

    if (errors) {
      $('.has-error').first()[0].scrollIntoView(false);
    }

    if ($('.js-virtualize-agreement-tos').length && !$('.js-virtualize-agreement-tos').is(':checked')) {
      $('.js-virtualize-agreement-tos-required').show();
      errors = true;
    }
    return !errors;
  });
}

ubian.cardVirtualize.virtualUploadProfileImage = function () {
  if (!$("#virtualize-profile-photo").val()) {
    return;
  }

  var $formData = new FormData();
  $formData.append("file", $("#virtualize-profile-photo")[0].files[0]);
  $formData.append("fileType", "1");
  $formData.append("validateFace", "true");
  $('.customer-photo-preview').html(ubian.utils.loader());
  $.ajax(
    ubian.routes["card_buy_upload"].replace(
      "--type--",
      'emulated'
    ),
    {
      type: "POST",
      data: $formData,
      cache: false,
      contentType: false,
      processData: false,
      success: function (result) {
        $('.customer-photo-preview').html('');
        $('.profile-photo-error').html('');
        $("#virtualize-profile-photo").val("");
        //$(".js-photo-preview-wrapper").removeClass("loading");
        if (result.error) {
          ubian.utils.alert(ubian.translate(result.error));
          //$(".js-photo-preview-wrapper").addClass("empty");
        } else if (result.url) {
          $(".customer-photo-preview").css(
            "background-image",
            'url("' + result.url + "&v=" + new Date() * 1 + '")'
          );
          //ubian.cardBuyType.updateContinueButton();
        }
      },
      error: function (xhr, status, error) {
        $('.customer-photo-preview').html('');
      }
    }
  );
};




$(function () {
  ubian.cardVirtualize.init();
});
